module.exports = __webpack_public_path__ + "img/guanggao.eb676a53.png";